import Configuracion from './configuracion';
import Planeacion from './planeacion';
import Adjudicaciones from './adjudicaciones';
import Contratos from './contratos';
import Licitaciones from './licitaciones';
import Ejecucion from './ejecucion';
import Estimaciones from './estimaciones';
import Consultas from './consultas';
import Presupuestos from './presupuestos';
import Programacion from './programacion';
import Pagos from './pagos';
import PerfilUsuario from './perfilusuario';
import Denegadas from './denegadas';
import Mapas from './mapas';

const administracion = [
  ...Configuracion,
  ...Planeacion,
  ...Adjudicaciones,
  ...Contratos,
  ...Licitaciones,
  ...Ejecucion,
  ...Estimaciones,
  ...Consultas,
  ...Presupuestos,
  ...Programacion,
  ...Pagos,
  ...PerfilUsuario,
  ...Denegadas,
  ...Mapas,
];

export default administracion;
